import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      paddingBottom: 60
    },
    totalBox: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    subTxt: {
      fontWeight: 400,
      color: "#999999",
      marginLeft: "3px"
    },

    soldToWrapper: {
      background: "#FFFFFF",
      border: `2px solid ${theme.palette.info.dark}`,
      borderRadius: 16,
      padding: "16px 16px 16px 16px",
      marginBottom: 24
    },
    soldToTitle: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: 16
    },
    displayInline: {
      display: "inline-block"
    },
    sendMailIcon: {
      color: theme.palette.info.main,
      height: 17
    },
    sendMailBtn: {
      padding: "3px 12px 3px 5px"
    },
    tabB: {
      marginLeft: "-3rem"
    },
    buttonTab: {
      border: 0
    },
    active: {
      backgroundColor: theme.palette.info.main,
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    },
    notActive: {
      backgroundColor: theme.palette.grey[300],
      "& .MuiTypography-root": {
        color: theme.palette.grey[600]
      }
    },
    tabBox: {
      display: "flex"
    },
    subHeading: {
      fontSize: "14px",
      color: "#696969",
      display: "flex",
      fontWeight: "normal"
    },
    boxTable: {
      border: `solid 1px #007E92`,
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTable-root": {
        borderCollapse: "collapse"
      },
      "& .MuiTableCell-root": {
        padding: "0px 12px",
        border: `1px solid ${theme.palette.grey[300]}`,
        height: "48px",
        "&:first-child": {
          paddingLeft: 12,
          paddingRight: 12
        }
      },
      "& .MuiTableRow-root": {
        "&.tableRowFooter": {
          background: "#FFFFFF !important",
          "&:hover": {
            background: "#FFFFFF !important"
          }
        }
      },
      "& .MuiTableCell-head": {
        "& .MuiTypography-root": {
          lineHeight: "18px"
        }
      },
      "& .MuiTableCell-body": {
        height: "40px",
        "& .MuiTypography-root": {
          lineHeight: "18px"
        }
      }
      // "& .MuiTypography-root": {
      //   lineHeight: "18px"
      // },
      // "& .myTypography-body3-137": {
      //   lineHeight: "18px"
      // }
    },
    tableContainer: {
      maxHeight: "60vh"
    },
    tableTabActive: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "33px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.info.dark,
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTabActive: {
      textTransform: "uppercase",
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "32px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "33px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.grey[400],
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTab: {
      textTransform: "uppercase",
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "32px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    zMax: {
      zIndex: 100
    },
    freeze_1: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 3
    },
    zIndex1: {
      zIndex: 1
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    rowFlex: {
      display: "flex",
      alignItems: "center"
    },
    tableFilterContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "end",
      marginBottom: 24
    },
    selectLanguageForm: {
      width: "auto"
    },
    selectLanguageField: {
      height: 36,
      width: 100,
      "& .MuiSelect-root": {
        padding: "0 1.2rem"
      }
    }
  }),
  { name: "OrderListTableAdmin" }
);

export default useStyles;
